module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Sha-Drach_Qawly.b4765003.webp";